<mat-sidenav-container class="sidenav-container" [hasBackdrop]="hasBackdrop()">
  <mat-sidenav
    #sidenav
    [mode]="mode()"
    [opened]="opened()"
    (closed)="closedChange.emit(false)"
    class="sidenav">
    <div class="sidenav-content">
      <ng-content></ng-content>
    </div>
  </mat-sidenav>

  <mat-sidenav-content>
    <ng-content select="[content]"></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>

